import React,{Component} from 'react'
import Map from '../components/Map'
import AOS from "aos";
import CompanyLogos from '../components/CompanyLogos'
import ActiveWrapper from '../components/common/ActiveWrapper'
import axios from 'axios'
import {getDomain,postCall} from '../components/common/domain'

let regix = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const center = { lat: 12.9289354, lng: 77.6267649 }

const mapProps = {
    options: {
        center,
        zoom: 18,
    },
    onMount: map => {
        new window.google.maps.Marker({
            position: center,
            map,
            title: 'Hubbler',
        })
    },
}


export default class Sales extends Component{
    state = {
        name:'',
        email:'',
        mobile:'',
        description:'',
        loading:false,
        sent:false,
        domain:''
    }
    submitValidate(){
        const {name,email,mobile,description} = this.state;
        const checkFormat = regix.test(this.state.email);
        return name !== '' && (email !== '' && checkFormat)
    }
    onChangeHandler(name,event){
        this.setState({
            [name]:event.target.value
        })
    }
    componentDidMount() {
        let domain = getDomain();
        this.setState({
            domain
        })
    }
    onSubmit(){
        const postData = {...this.state};
        delete  postData.loading
        delete  postData.sent
        this.setState({
            loading:true
        })
        postCall('/hubbler/customer-support/',postData).then((response)=>{
            if(response.data.success){
                this.setState({
                    loading:false,
                    sent:true
                })
            }else {
                alert(response.data.error)
            }
        });

    }
    render(){
        const checkFormat = regix.test(this.state.email);
        const {name,email,mobile,description} = this.state
        return <div className={'sales-form-page form-page-container'}>
            <ActiveWrapper active={!this.state.sent}>
                <div className={'form-inputs-container'}>
                    <div className={'info-details'}>
                        <div className={'head'}>Customer Support</div>
                        <p>Get in touch with customer support for assistance with your Hubbler product queries. Also, the top queries are listed in our <a href="https://help.hubbler.mobi/faq/" target="_blank">FAQs</a>, do check it out.</p>
                    </div>
                    <div className={this.state.loading ? 'inputs-list loading-disable' : 'inputs-list'}>
                        <div className={'inputs'}>
                            <label>Name</label>
                            <input type="text" placeholder={'e.g., John Smith'} autoFocus={true} onChange={this.onChangeHandler.bind(this,'name')} defaultValue={name} disabled={this.state.loading ? true :false}/>
                        </div>
                        <div className={'inputs'}>
                            <label>Company Email</label>
                            <input type="email" placeholder={'name@company.com'}  onChange={this.onChangeHandler.bind(this,'email')} defaultValue={email} disabled={this.state.loading ? true :false} className={'email-focus'}/>
                            {(checkFormat || this.state.email === '') ? '' : <span className={'text-danger'}>email format is not correct</span>}
                        </div>
                        <div className={'inputs'}>
                            <label>Phone No</label>
                            <input type="number" placeholder={'+91 9988 766 554'} onChange={this.onChangeHandler.bind(this,'mobile')}  defaultValue={mobile} disabled={this.state.loading ? true :false}/>
                        </div>
                        <div className={'inputs'}>
                            <label>What would you like to discuss?</label>
                            <textarea rows="5" placeholder={'Share a few details of the solution you are looking to find or wait! Let us get on a call & we will figure it out, for you.'}  defaultValue={description} onChange={this.onChangeHandler.bind(this,'description')} disabled={this.state.loading ? true :false}/>
                        </div>
                    </div>
                    <div className={'footer'}>
{/*
                        <button className={'cancel'}>Cancel</button>
*/}
                        <button className={this.submitValidate() ? 'submit bt-blue' : 'submit bt-blue disable'} id={this.state.loading ? 'bt-loading' : ''} onClick={this.onSubmit.bind(this)}>Submit</button>
                    </div>
                </div>
            </ActiveWrapper>
            <ActiveWrapper active={this.state.sent}>
                <div className={'form-inputs-container'}>
                    <div className={'info-details'}>
                        <div className={'head'}>We have received your Support request</div>
                        <p>Our team will get back to you soon.</p>
                    </div>
                </div>
            </ActiveWrapper>
            <div className={'form-inputs-container'}>
                <div className={'info-details'}>
                    <div className={'head'}>Trusted by the world’s best</div>
                </div>
            </div>
            <CompanyLogos/>
            {/*<div className={'contact-us-main-page'}>
            <div className={'company-info-address'}>
                <div className={'company-info-address-cls'}>
                    <div className={'address-cls'}>
                        <div className={'address-one address-info'}>
                            <div className={'head'}>Corporate Headquarters</div>
                            <div className={'address'}>Hubbler Pvt Ltd</div>
                            <div className={'address'}>#147/J, 3rd Floor, 10th Cross, 12th Main,<br/> 3rd Block, Koramangala, Bangalore - 34</div>
                        </div>
                        <div className={'address-two address-info'}>
                            <div className={'head'}>Sales Info & Inquiries</div>
                            <div className={'address'}>Hubbler Pvt Ltd</div>
                            <div className={'address'}>Landline: +91 80 4200 1415</div>
                            <div className={'address'}>Email: connect@hubbler.mobi</div>
                        </div>
                    </div>
                    <div className={'map'}>
                     <Map id="contactMap" {...mapProps} />
                    </div>
                </div>
            </div>
            </div>*/}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/customerSupport.js